import axios from 'axios';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { useEffect, useState } from 'react';
import { FaArrowRight } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import '../HomePage.css';

// const BASE_URL = "http://localhost:8000";
const BASE_URL = "https://idealpursuits.co.in/api";

const ExpertConnectSection = () => {
    const [experts, setExperts] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('All');
    const [visibleCount, setVisibleCount] = useState(8);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchExperts = async () => {
            try {
                const response = await axios.post(`${BASE_URL}/expert/getExpertsDetails.php`);
                setExperts(response.data);
            } catch (error) {
                console.error('Error fetching expert data:', error);
            }
        };

        fetchExperts();
    }, []);

    const categories = ['All', ...new Set(experts.map(expert => expert.category))];

    // Filtering happens on the full dataset, then slicing
    const filteredMentors = selectedCategory === 'All'
        ? experts
        : experts.filter(expert => expert.category === selectedCategory);

    const visibleMentors = filteredMentors.slice(0, visibleCount);

    return (
        <section className="mentors-section" id="experts">
            <div className="container mx-auto py-12">
                <h2>Direct Access to Industry Experts</h2>
                <p className="expert-detailed-text">
                    <span className="highlighted-text">Real-Time Guidance:</span> Our platform offers real-time access to experts across various industries, from developers to product managers and data scientists.
                </p>
                <p className="expert-additional-info">
                    Get your career questions answered and make better decisions with expert advice, all from the comfort of your home.
                </p>
                <p className="text-gray-600 mb-8">
                    Are you willing to enroll as an Industry Expert? <a href="/#/professional-enrollment">Enroll Now</a>
                </p>

                {/* Category Filter */}
                <div className="category-filters">
                    {categories.map(category => (
                        <button
                            key={category}
                            onClick={() => { setSelectedCategory(category); setVisibleCount(8); }}
                            className={`px-4 py-2 rounded-full text-sm font-semibold ${selectedCategory === category ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-700'}`}
                        >
                            {category}
                        </button>
                    ))}
                </div>

                {/* Mentor Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {visibleMentors.map((expert, index) => (
                        <motion.div
                            key={index}
                            className="mentor-card bg-white shadow-lg rounded-lg overflow-hidden flex flex-col"
                            initial={{ opacity: 0, scale: 0.9 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, ease: 'easeOut' }}
                        >
                            <img
                                src={`${BASE_URL}/images/profile/${expert.profileImageName}`}
                                alt={expert.name}
                                className="w-full h-48 object-cover"
                            />
                            <div className="p-6 flex flex-col flex-grow">
                                <h3 className="text-xl font-bold mb-2">{expert.name}</h3>
                                <p className="text-gray-500 mb-4">{expert.profession}</p>
                                <p className="mb-4">{expert.experience}</p>
                                <div className="flex items-center mb-4">
                                    <Star className="w-5 h-5 text-yellow-400 mr-1" />
                                    <span className="text-gray-700 font-bold">{expert.rating.toFixed(1)}</span>
                                </div>
                                <div className="mt-auto">
                                    <button 
                                        className="cta-button w-full"
                                        onClick={() => navigate(`/professional-profile/${expert.expertId}`)}
                                    >
                                        Book Now
                                    </button>
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </div>

                {/* Load More Button */}
                {visibleCount < filteredMentors.length && (
                    <div className="flex justify-center mt-6">
                        <button
                            onClick={() => setVisibleCount(prev => prev + 8)}
                            className="load-more-button px-6 py-3 bg-blue-500 text-white rounded-full font-semibold"
                        >
                            Load More
                        </button>
                    </div>
                )}
            </div>

            <button onClick={() => navigate('/professionals')} className="more-button">
                View All Professionals
                <FaArrowRight className="arrow-icon" />
            </button>
        </section>
    );
};

export default ExpertConnectSection;
